import is from '@sindresorhus/is';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

import { useJobArchitectureOptions } from '../api/use-job-architecture-options';

export type JobArchitecturePermissions = {
    readonly canModify: boolean;
    readonly canRead: boolean;
};

const defaultPermissions: JobArchitecturePermissions = {
    canModify: false,
    canRead: false,
};

export const JobArchitecturePermissionsContext = createContext<JobArchitecturePermissions>(defaultPermissions);

export const JobArchitecturePermissionsContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { data } = useJobArchitectureOptions();

    const permissions: JobArchitecturePermissions = !is.nullOrUndefined(data)
        ? {
              canModify: data.canCreate,
              canRead: data.canRead,
          }
        : defaultPermissions;

    return (
        <JobArchitecturePermissionsContext.Provider value={permissions}>
            {children}
        </JobArchitecturePermissionsContext.Provider>
    );
};

export const useJobArchitecturePermissions = (): JobArchitecturePermissions => {
    const context = useContext(JobArchitecturePermissionsContext);

    if (context === null) {
        throw new Error('useJobArchitecturePermissions must be used within JobArchitecturePermissionsContextProvider');
    }

    return context;
};
